<template>
  <b-card class="shadow-sm">
    <b-card-body class="mb-4 px-6 pt-6">
      <!-- LOADING -->
      <div v-if="loading">
        <b-row class="text-center">
          <div class="col-6 border-right">
            <b-skeleton width="60%" height="18px" class="mx-auto mb-3" />
            <b-skeleton width="70%" height="48px" class="mx-auto" />
          </div>
          <div class="col-6">
            <b-skeleton width="60%" height="18px" class="mx-auto mb-3" />
            <b-skeleton width="70%" height="48px" class="mx-auto" />
          </div>
        </b-row>
      </div>

      <!-- CONTEÚDO -->
      <div v-else>
        <b-row class="text-center">
          <div
            class="col-6 border-right"
            style="cursor: pointer"
            @click="$router.push({ name: 'contasReceber' })"
          >
            <b-card-title class="mb-5">
              <b-icon
                icon="arrow-down-circle-fill"
                color="#2ECC71"
                class="mr-2"
              />
              <span>A receber hoje</span>
            </b-card-title>
            <h2
              class="display-4 mb-0 font-weight-bold"
              :style="{
                color: '#2ECC71',
                opacity: totalReceberHoje > 0 ? 1 : 0.7,
              }"
            >
              {{ formatCurrency(totalReceberHoje) }}
            </h2>
          </div>

          <div
            class="col-6"
            style="cursor: pointer"
            @click="$router.push({ name: 'contasPagarLista' })"
          >
            <b-card-title class="mb-5">
              <b-icon
                icon="arrow-up-circle-fill"
                color="#E74C3C"
                class="mr-2"
              />
              <span>A pagar hoje</span>
            </b-card-title>
            <h2
              class="display-4 mb-0 font-weight-bold"
              :style="{
                color: '#E74C3C',
                opacity: totalPagarHoje > 0 ? 1 : 0.7,
              }"
            >
              {{ formatCurrency(totalPagarHoje) }}
            </h2>
          </div>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "TotalizadorContasHoje",
  props: {
    totaisFinanceiros: {
      type: Object,
      default: () => ({
        totalPagarHoje: 0,
        totalReceberHoje: 0,
      }),
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  computed: {
    totalPagarHoje() {
      return Number(this.totaisFinanceiros?.totalPagarHoje ?? 0);
    },
    totalReceberHoje() {
      return Number(this.totaisFinanceiros?.totalReceberHoje ?? 0);
    },
  },
  methods: {
    formatCurrency(v) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(v ?? 0);
      } catch {
        return `R$ ${(v ?? 0).toFixed(2)}`;
      }
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: rgba(0, 123, 255, 0.05); /* leve destaque */
  transition: background-color 0.2s ease;
}
</style>
